import { Component, h, State, Event, type EventEmitter, Prop } from '@stencil/core';
import type { ReflectedTab } from '../../SearchCompletedEvent';
import { makeLogger } from '../../../logger/logger';
import type { labelProviderInterface } from '../../LabelProviderInterface';

const { warn } = makeLogger({
  pathToCurrentFile: 'components/result-page/server-error/uiaas-search-server-error.tsx',
  loggersList: ['warn']
});

@Component({
  tag: 'uiaas-search-server-error',
  shadow: true,
  styleUrl: 'uiaas-search-server-error.scss',
})
export class UiaasSearchServerError {
    /**
     * Provides a string with query value fo the component
     */
    @Prop() readonly query: string;

    /**
     * label provider
     */
    @Prop({ mutable: true })
      labelProvider?: labelProviderInterface;

    @Prop() readonly reflectedState: ReflectedTab;

    componentWillLoad() {
        if (!this.labelProvider) {
          this.labelProvider = (name, fallback) => {
              warn(
                'Label provider not defined for the component ',
                this,
                [name, fallback]
              );
              return fallback;
          };
        }
    }

    render() {
        if (
          !this.reflectedState.ajaxIsLoading &&
            this.reflectedState.hasError
        ) {
          return (
            <div class="server-error__container">
              <h3 class="server-error__title">
                {this.labelProvider(
                  'something-went-wrong',
                  'Something went wrong'
                )}
              </h3>
              <p>
                {this.labelProvider(
                  'refine-and-try-again',
                  'Please refine your query and try again.'
                )}
              </p>
              <p class="server-error__description">
                {this.labelProvider(
                  'contact-administrator',
                  'If it doesn\'t help, contact your administrator.'
                )}
              </p>
            </div>
          );
        }
    }
}
